import { api } from '@/services';
import type { ItemDocumento } from '@/services/Documentos/types';

export interface ListaItensSimplesFiltro {
  ModeloDocumento: string;
  ChaveAcesso: string;
  CNPJ_Gestor: string;
  CNPJ_Contribuinte: string;
  DataInicio: string;
  DataFim: string;
  CFOP: string;
  CClasTrib: string;
  Pagina: number;
  QtdPorPagina: number;
}

export interface GrupoItensSimples {
  totalPagina: number;
  totalItens: number;
  items: ItemDocumento[];
}

export interface ListaDocumentosItensSimplesResponse {
  status: { resultado: boolean; mensagem: string };
  documents: {
    nfe?: GrupoItensSimples;
    nfc?: GrupoItensSimples;
  };
}

export async function fetchListaDocumentosItensSimples(
  filtro: ListaItensSimplesFiltro
): Promise<ListaDocumentosItensSimplesResponse> {
  return api.post<ListaDocumentosItensSimplesResponse, ListaItensSimplesFiltro>(
    'TurboPro/SimplesNacional/ListaDocumentosItens',
    filtro
  );
}
